export default __webpack_public_path__ + "static/adorno2-fc1ce54ca44497275833ff5aeefcfcac.png";